import React from 'react';

import {Button} from 'components/Button';
import {Modal} from 'components/Modal';

import styles from 'css_modules/SaveModal.module.css';

export const ConfirmSaveModal = ({close, clicked}) => {
    return (
        <div className={styles.ontop}>
            <Modal name={'Uložit změny'} close={close}>
                <div className={styles.column}><br></br>
                    Opravdu chcete provést změny v již vydaném dokladu?
                </div>

                <div className={styles.buttons}>
                    <div className={styles.button}>
                        <Button onClick={close}>Zrušit</Button>
                    </div>

                    <div className={styles.savebutton}>
                        <Button onClick={clicked} primary={true}>Uložit</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
